<!-- 自定义 MessageBox 组件 -->
<template>
  <div class="subscribe-dialog" v-show="isShowMessageBox">
    <div class="mask" @click="cancel"></div>
    <!-- <div class="mask"></div> -->
    <div class="subscribe-dialog-con">
      <div class="close" @click="cancel"><i></i></div>
      <h3 class="header-title">{{ title }}</h3>
      <div class="content">
        <ul>
          <li v-for="(item,key) in dateLink" :key="key">
            <a :href="item.linkurl" target="_blank" class="share-facebook">
              <img v-lazy="{src:item.picurl,loading:require('../../../../static/img/loading/loading-1-1.jpg'),error:require('../../../../static/img/loading/loading-1-1.jpg')}" alt="">
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
 
<script>
  export default {
    props: {
      title: {
        type: String,
        default: '标题'
      },
      content: {
        type: String,
        default: '这是弹框内容'
      },
      dateLink: {
        type: Array,
        default: function(){
          return [];
        }
      },
    },
    computed:{
      params(){ 
        return [];
      }
    },
    data () {
      return {
        isShowMessageBox: false,
        shareLink:{},
      };
    },
    watch: {
      dateLink: function(newVal,oldVal){
        this.dateLink = newVal;  //newVal即是chartData
        this.getPlatsDate();
      }
    },
    methods: {
      // 确定,将promise断定为resolve状态
      confirm: function () {
        this.isShowMessageBox = false;
        // this.remove();
      },
      // 取消,将promise断定为reject状态
      cancel: function () {
        this.isShowMessageBox = false;
        // this.remove();
      },
      // 弹出messageBox,并创建promise对象
      showMsgBox: function () {
        this.isShowMessageBox = true;
      },
      remove: function () {
        setTimeout(() => {
          this.destroy();
        }, 300);
      },
      destroy: function () {
        this.$destroy();
        document.body.removeChild(this.$el);
      },
      getPlatsDate(){
        var _this = this;
        console.log(_this.dateLink)
      },
    },
    created(){

    },
    mounted(){
      
    },
  };
</script>
 
<style scoped lang="scss">
.subscribe-dialog {
  position: relative;
  .mask {
    position: fixed;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50000;
    background: rgba(0, 0, 0, 0.7);
  }
  .subscribe-dialog-con {
    position: fixed;
    box-sizing: border-box;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 50001;
    border-radius: 10px;
    width: 922px;
    .close {
      position: absolute;
      top: 15px;
      right: 20px;
      width: 20px;
      height: 20px;
      background: url('../../../../static/img/close.png') no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .header-title {
      height: 50px;
      font-size: 16px;
      color: #999999;
      font-weight: 400;
      font-family: HelveticaLTPro-Light;
      line-height: 54px;
      text-align: center;
    }
    .content {
      border-top: 1px solid #dddddd;
      padding: 0px 50px 18px;
      ul{
        overflow: hidden;
        clear: both;
        li{
          width: 57px;
          height: 57px;
          margin-left: 52px;
          float: left;
          margin-top: 18px;
          &:first-child{
            margin-left: 0;
          }
          &:nth-of-type(8n+1){
            margin-left: 0;
          }
          a{
            display: block;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1560px) and (min-width: 1261px){

}

@media screen and (max-width: 1260px) and (min-width: 769px){
  .subscribe-dialog {
    .subscribe-dialog-con {
      width: 680px;
      .content {
        padding: 0px 40px 18px;
        ul{
          li{
            margin-left: 40px;
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px){
  .subscribe-dialog {
    .subscribe-dialog-con {
      width: 20rem;
      .close {
        position: absolute;
        top: .83rem;
        right: 1.11rem;
        width: 1.11rem;
        height: 1.11rem;
        background: url('../../../../static/img/close.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
      .header-title {
        height: 2.78rem;
        font-size: .89rem;
        color: #999999;
        font-weight: 400;
        font-family: HelveticaLTPro-Light;
        line-height: 3rem;
        text-align: center;
      }
      .content {
        border-top: 1px solid #dddddd;
        padding: 0 1rem 1rem;
        ul{
          overflow: hidden;
          clear: both;
          li{
            width: 2.8rem;
            height: 2.8rem;
            margin-left: 1rem;
            float: left;
            margin-top: 1rem;
            &:first-child{
              margin-left: 0;
            }
            &:nth-of-type(8n+1){
              margin-left: 1rem;
            }
            &:nth-of-type(5n+1){
              margin-left: 0;
            }
            a{
              display: block;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/subscribe-dialog/index.vue